module.exports = __webpack_public_path__ + "img/Princessed.1c121184.svg";